// defines "analytics" (Segment) & "Bugsnag" as undefined
// in the case that the scripts fail at loading.  variable
// needs to be set to undefined to avoid a reference error
// when detecting their state before firing events
var analytics = analytics || undefined;
var Bugsnag = Bugsnag || undefined;
var ga = ga || undefined;

/* global: _ */

// namespace for all analytics integrations
var analyticsIntegrations = {};

analyticsIntegrations.getGoogleAnalyticsID = function() {
  var currClientID;
  if (!ga) {
    currClientID = null;
  } else {
    ga(function(tracker) { currClientID = tracker.get('clientId'); });
  }
  return currClientID;
};

// checks segment state
analyticsIntegrations.segmentLoaded = function() {
  var isDefined = analytics ? true : false;
  return isDefined;
};

analyticsIntegrations.mergeObject = function(obj, objToAdd){
  for (var attrname in objToAdd) {
    if (objToAdd.hasOwnProperty(attrname)) {
      obj[attrname] = objToAdd[attrname];
    }
  }
  return obj;
};

// checks bugsnag state
analyticsIntegrations.bugsnagLoaded = function() {
  var isDefined = Bugsnag ? true : false;
  return isDefined;
};

// identifies version & env for bugsnag
analyticsIntegrations.bugsnagDetails = function() {
  if (!analyticsIntegrations.bugsnagLoaded()) {return;}
  // Bugsnag.appVersion = version;
  // Bugsnag.releaseStage = env;
};

analyticsIntegrations.pageUrl = function(){
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  var page;
  var locationPath = location.pathname;
  page = locationPath.replace("/app/", "").replace("/","");
  return page;
};

analyticsIntegrations.getOrigin = function () {
  var origin;
  if (document.referrer === (location.origin + '/')) {
    origin = 'home';
  } else if (-1 !== document.referrer.indexOf('/s/')) {
    origin = 'search';
  } else if (-1 !== document.referrer.indexOf('/u/')) {
    origin = 'use type';
  } else if (-1 !== document.referrer.indexOf('/venues/')) {
    slashCount = document.referrer.split('/').length;
    origin = 5 < slashCount ? 'keyword' : 'city';
  } else {
    origin = document.referrer;
  }
  return origin;
};

analyticsIntegrations.normalizeListingObj = function (listing) {
  var omitArray = [
    '_index',
    '_score',
    '_timestamp',
    '_type',
    'search_weights',
    'id',
    'images',
    'allImages',
    'amenities',
    'availabilityPatterns',
    'availability_array',
    'available_days',
    'canonical_loc_data',
    'cloudinary_images',
    'description',
    'duration_type',
    'emailShare',
    'encodeded_title_case',
    'fbShare',
    'images',
    'latitude',
    'listing_img_id',
    'listing_reviews',
    'location',
    'longitude',
    'orig_date_modified',
    'ownerACHAvailable',
    'ownerAvatarUrl',
    'ownerReviewStars',
    'owner_review_stars_array',
    'pinterestShare',
    'prices',
    'price.currency',
    'price.hourly',
    'rules',
    'space_review_stars_array',
    'stringify_listing',
    'status',
    'title',
    'truncated_description',
    'twitterShare',
    'use_neighborhood',
    'uses',
    'user_info',
    'useTypeBreadcrumb',
    'city',
    'country',
    'currency',
    'neighborhood',
    'ownerAvatarId',
    'ownerFirstName',
    'ownerLastName',
    'state',
    'zip'
  ];
  var normalizeListingObj = _.assign({}, _.omit(listing, omitArray));
  if (listing.listing_img_id) { normalizeListingObj.cover_img_id = listing.listing_img_id; }
  if (listing.id || listing._id) { normalizeListingObj.listing_id = listing.id ? listing.id : listing._id; }
  if (listing.page_title || listing.title) { normalizeListingObj.listing_title = listing.page_title ? listing.page_title : listing.title; }
  if (listing['price.currency']) { normalizeListingObj.currency_type = listing['price.currency']; }
  if (listing.uses && listing.uses.length) { normalizeListingObj.use_type = listing.uses[0]; }
  return normalizeListingObj;
};
// **** Custom Segment Function for Each Page **** //

//Hero Section
analyticsIntegrations.heroSectionEventListener = function(){
  var browseButton = document.getElementById("browse-btn");
  var becomeHostButton = document.getElementById("become-host-btn");
  if (browseButton) {
    analyticsIntegrations.itemClicked("button click", browseButton, "hero image button");
  }
  if (becomeHostButton) {
    analyticsIntegrations.itemClicked("button click", becomeHostButton, "hero image button");
  }
};

analyticsIntegrations.searchEventListener = function(){
  var searchBtn = document.getElementById("searchbar-submit-button");
  if (searchBtn) {
    analyticsIntegrations.itemClicked("button click", searchBtn, "search");
  }
};

analyticsIntegrations.searchDropdown = function (category, label) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('dropdown clicked', {
    category: category,
    label: label + ' dropdown'
  });
};

//Learn More
analyticsIntegrations.learnMoreSectionEventListener = function(){
  var learnMoreBtn = document.getElementById("learn-more");
  if (learnMoreBtn) {
    analyticsIntegrations.itemClicked("button click", learnMoreBtn, "iOS link");
  }
};

//Banner Section
analyticsIntegrations.bannerSectionEventListener = function(){
  var bannerButton = document.getElementById("banner-btn");
  var buttonText = $(bannerButton).data("type");
  if (bannerButton) {
    analyticsIntegrations.itemClicked("button click", bannerButton, buttonText);
  }
};

//Event Planning Section
analyticsIntegrations.eventPlanningSectionEventListener = function(){
  var eventPlanning = document.getElementById("event-planning-btn");
  if (eventPlanning) {
    analyticsIntegrations.itemClicked("button click", eventPlanning, 'Event planning link');
  }
};

//Join Us Section
analyticsIntegrations.joinUsEventListener = function(){
  var joinUsBtn = document.getElementById("join-us-btn");
  if (joinUsBtn) {
    analyticsIntegrations.itemClicked("button click", joinUsBtn, 'join link');
  }
};


//Download Page
analyticsIntegrations.joinUsEventListener = function(){
  var downloadBtn = document.getElementById("download-btn");
  if (downloadBtn) {
    analyticsIntegrations.itemClicked("button click", downloadBtn, 'iOS link');
  }
};
//Use-Type Page
analyticsIntegrations.conciergeSectionListener = function () {
  var conciergeButton = document.getElementById("concierge-button");
  if (conciergeButton) {
    analyticsIntegrations.itemClicked("button click", conciergeButton ,"Find Me A Space");
  }
};

analyticsIntegrations.trackEvent = function(event, properties, options, callback) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  analytics.track(event, properties, options, callback);
};
// End of Use-Type Page;

//Listings Page
analyticsIntegrations.listingsProductView = function (listingObject, originAction) {
  if (!analyticsIntegrations.segmentLoaded() || !listingObject) {return;}
  var useType, metro, neighborhood, category, origin, slashCount;
  var properties = {};
  if (originAction) {
    origin = originAction;
  } else if (-1 !== document.referrer.indexOf('/s/')) {
    origin = 'search';
  } else if (-1 !== document.referrer.indexOf('/u/')) {
    origin = 'use type';
  } else if (-1 !== document.referrer.indexOf('/venues/')) {
    slashCount = document.referrer.split('/').length;
    origin = 5 < slashCount ? 'keyword' : 'city';
  } else {
    origin = document.referrer;
  }

  priceObj = listingObject.prices;
  useType = listingObject.use_type;
  metro = listingObject.metro || "unknown";
  neighborhood = listingObject.neighborhood || "unknown";
  category = useType + "/" + metro + "/" + neighborhood;
  const searchKW = PSSessions.Cookies('PSSK');

  properties = analyticsIntegrations.normalizeListingObj(listingObject);
  properties.search_keyword = searchKW;
  properties.search_keyword_type = PSSessions.Cookies('PSSKT');
  // this is in the head tag of listing page
  properties.sort_rank = sortRank;
  properties.sku = listingObject._id;
  properties.origin = origin;
  properties.category = category;
  properties.price = listingObject.price;
  properties.nonInteraction = 1;
  analytics.track("Viewed Product", properties, {
    Quantcast: {
      labels: [ searchKW, useType ]
    }
  });
};

analyticsIntegrations.pageUrl = function pageUrl() {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  return location.pathname;
};

/* These Functions are currently in their respective components.
 Why, you may ask? Because requiring them wonks it all.
 */

analyticsIntegrations.availabilityBlock = function(originalTimesRequested, listing, conflictReason) {
  // if no conflict, function shouldn't be called
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = originalTimesRequested;
  var category = listing.use_type + "/" + listing.metro;

  properties.category = category;
  properties.reason_blocked = conflictReason; // add the reason for the conflict here
  analytics.track("availability blocked", properties);
};

analyticsIntegrations.messageTrack = function messageSent(str, messageObject, usrObj) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {};
  properties = messageObject;
  var pageName = analyticsIntegrations.pageUrl();
  properties.search_keyword = PSSessions.Cookies('PSSK');
  properties.search_keyword_type = PSSessions.Cookies('PSSKT');
  properties["page name"] = pageName;
  properties.category = messageObject.use_type + "/" + messageObject.metro;
  properties.label = pageName;
  if (messageObject.update_organization || messageObject.update_profession) {
    var sentUsrObj = {};
    if (messageObject.update_organization) {
      sentUsrObj.organization = usrObj.organization;
    }
    if (messageObject.update_profession) {
      sentUsrObj.title = usrObj.profession;
    }
    sentUsrObj.ssoId = usrObj.ssoId;
    analytics.identify(usrObj.ssoId, sentUsrObj);
  }
  analytics.track(str, properties);
};

analyticsIntegrations.transactableViewed = function transactableViewed(missingArray) {
  if (!analyticsIntegrations.segmentLoaded() || !window.listingJSON) { return; }
  var properties = {"blockers": missingArray};
  properties.category = "Account";
  properties.label = missingArray;
  properties["page name"] = analyticsIntegrations.pageUrl();
  analytics.track("transactable blocker viewed", properties);
};

analyticsIntegrations.favorited = function favorited(added, listingObj, origin) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = listingObj;
  if (!added) {
    properties.status = "removed";
  } else {
    properties.status = "added";
  }
  properties.label = properties.status;
  properties.origin = origin;
  properties.category = properties.use_type + "/" + properties.metro;
  analytics.track("favorited", properties);
};

analyticsIntegrations.createBoardViewed = function createBoardViewed (isFirstTime, listing, origin, activity, useType, listingImgID) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = listing;

  properties.is_first_time = isFirstTime;
  properties.origin = origin;
  properties.label = origin;
  properties.activity = activity;
  properties.listing_img_id = listingImgID;

  properties.category = useType + "/" + properties.metro;
  analytics.track("board form viewed", analyticsIntegrations.normalizeListingObj(properties));
};

analyticsIntegrations.boardCreated = function boardCreated (isFirstTime, listing, origin, activity, useType, listingImgID, project) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = listing;

  properties.is_first_time = isFirstTime;
  properties.origin = origin;
  properties.label = origin;
  properties.activity = activity;
  properties.listing_img_id = listingImgID;

  properties.category = useType + "/" + properties.metro;

  properties.board_event_date = project.created;
  properties.board_activity = project.activity;
  properties.board_location = project.location;

  analytics.track("board created (frontend)", analyticsIntegrations.normalizeListingObj(properties));
};

analyticsIntegrations.listBoardViewed = function listBoardViewed (isFirstTime, listing, origin, activity, useType, listingImgID, boardsCount) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = listing;

  properties.is_first_time = isFirstTime;
  properties.origin = origin;
  properties.label = origin;
  properties.activity = activity;
  properties.listing_img_id = listingImgID;

  properties.category = useType + "/" + properties.metro;

  properties.boards_viewed = boardsCount;

  analytics.track("board list viewed", analyticsIntegrations.normalizeListingObj(properties));
};

analyticsIntegrations.boardListingsSaved = function boardListingsSaved (listing, origin, activity, useType, listingImgID, isCreate, boardsSelected) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = listing;
  properties.origin = origin;
  properties.label = origin;
  properties.activity = activity;
  properties.listing_img_id = listingImgID;
  properties.use_type = useType;
  properties.category = useType + "/" + properties.metro;

  properties.on_board_created = isCreate;
  properties.boards_selected = boardsSelected;

  analytics.track("listing saved (frontend)", analyticsIntegrations.normalizeListingObj(properties));
};

analyticsIntegrations.bookingPriceCreated = function(feeObj){
  if (!analyticsIntegrations.segmentLoaded() || !listingJSON) {return;}
  var pageName = analyticsIntegrations.pageUrl();
  var properties = feeObj;
  var category = listingJSON.use_type +"/"+listingJSON.metro;
  properties.category = category;
  properties.label = pageName;
  properties.search_keyword = PSSessions.Cookies('PSSK');
  properties.search_keyword_type = PSSessions.Cookies('PSSKT');
  analytics.track("booking price created", properties);
};

analyticsIntegrations.startBooking = function(parsedUrl, origin) {
  if (!analyticsIntegrations.segmentLoaded() || !listingJSON) { return; }
  var properties = listingJSON;
  properties.category = properties.page_title + "/" + properties.metro;
  properties.sort_rank = parsedUrl.sort_order;
  properties.origin = origin;
  analytics.track("start booking", properties);
};

analyticsIntegrations.carouselOpened = function carouselOpened () {
  if (!analyticsIntegrations.segmentLoaded() || !listingJSON) { return; }
  var properties = listingJSON;
  analytics.track("carousel opened", properties);
};
// End of Listing Page

//Public: shared segment code
analyticsIntegrations.itemClicked = function(itemTitle, element, elementName, sharedObject, clickTarget, clickArea){
  // if (!analyticsIntegrations.segmentLoaded() || !sharedObject) {return;}
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  var properties = {}, category, pageName, categoryName, elementClicked, elementSelected, parsedSharedObj;
  var sessions = PSSessions.Cookies('PSAccess');
  elementSelected = elementName;
  if(sharedObject){
    parsedSharedObj = JSON.parse(sharedObject);
    properties = parsedSharedObj;
  } else {
    parsedSharedObj = {};
  }
  if('undefined' !== typeof websiteJSON){
    if('index' === websiteJSON.page){
      pageName = 'home';
      categoryName = "home";
    } else {
      pageName = websiteJSON.page;
      categoryName = websiteJSON.page;
    }
  }
  if('undefined' !== typeof useTypeJSON){
    pageName = "use type landing page";
    categoryName = "use type landing page";
    properties.use =  useTypeJSON.use_type;
    properties.metro = useTypeJSON.metro;
  }
  if('undefined' !== typeof listingJSON){
    var use, metro; //for listings
    use = parsedSharedObj.use;
    use = properties.use;
    metro = parsedSharedObj.metro;
    pageName = "SEO listing";
    categoryName = use +"/"+ metro;
  }
  if('undefined' !== typeof profileJSON){
    properties = parsedSharedObj;
    pageName = "profile";
    categoryName = "profiles";
  }

  properties["page name"] = pageName;
  properties.selection = elementSelected;
  properties["click target"] = clickTarget;
  properties.label = elementSelected;
  properties.area = clickArea;
  properties.category = categoryName;
  analytics.trackLink(element, itemTitle, properties);
};

//Referral Page
analyticsIntegrations.trackReferralClick = function (source) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  var properties = {
    button: 'referral',
    source: source,
    destination: 'referrals'
  };
  analytics.track('referral clicked', properties);
}


// Share Event Listner
analyticsIntegrations.addShareEventListeners = function() {
  var pinterestButton, fbButton, emailButton, twitterButton, sharedJSON;
  pinterestButton = document.getElementById('pinterest');
  fbButton = document.getElementById('fb');
  twitterButton = document.getElementById('twitter');
  emailButton = document.getElementById('email');

  // Checks for Global JSON object
  if('undefined' != typeof listingJSON){
    sharedJSON = listingJSON;
  }
  if('undefined' != typeof profileJSON){
    sharedJSON = profileJSON;
  }
  sharedJSON = JSON.stringify(sharedJSON);
  // Adds Event listeners to share buttons
  if (pinterestButton) {
    analyticsIntegrations.itemClicked("share button clicked", pinterestButton, "pinterest", sharedJSON);
  }
  if (fbButton) {
    analyticsIntegrations.itemClicked("share button clicked", fbButton, "facebook", sharedJSON);
  }
  if (emailButton) {
    analyticsIntegrations.itemClicked("share button clicked", emailButton, "email", sharedJSON);
  }
  if (twitterButton) {
    analyticsIntegrations.itemClicked("share button clicked", twitterButton, "twitter", sharedJSON);
  }
};
analyticsIntegrations.addListingBlockEventListeners = function(){
  var listingAnalytics =  document.getElementsByClassName('listing-analytics');
  var listingImg = document.getElementsByClassName('listing-img');
  var listingTitle = document.getElementsByClassName('listing-title');
  var listingLink = document.getElementsByClassName('listing-link');

  for (var i = 0; i < listingAnalytics.length; i++) {
    var listingJSON = $(listingAnalytics[i]).data("listing");
    listingJSON = JSON.stringify(listingJSON);
    if(listingImg[i]){
      analyticsIntegrations.itemClicked("listing selected", listingImg[i], null, listingJSON, "thumbnail");
    }
    if(listingTitle[i]){
      analyticsIntegrations.itemClicked("listing selected", listingTitle[i], null, listingJSON, "title");
    }
    if(listingLink[i]){
      analyticsIntegrations.itemClicked("listing selected", listingLink[i], null, listingJSON, "description link");
    }
  }
};

analyticsIntegrations.addNavFooterListeners = function() {
  var destination, addFooterListener, addHeaderListener,
      elementsForLinkTrack;

  // these are the basic destination names that have links
  // throughout the site
  elementsForLinkTrack = [
    "about",
    "careers",
    "guest",
    "host",
    "blog",
    "support",
    "terms",
    "privacy",
    "signin",
    "signup",
    "home",
    "mobile",
    "download",
    "add_space",
    "search",
    "facebook",
    "twitter",
    "googleplus",
    "linkedin",
    "pinterest"
  ];

  // adds footer link listeners
  addFooterListener = function(dest) {
    var elementName, element;
    elementName = "footer_link_" + dest;
    element = document.getElementById(elementName);
    if (element) {analyticsIntegrations.itemClicked("nav clicked", element, dest, null, null, elementName);}
  };

  // adds header bar link listeners
  addHeaderListener = function(dest) {
    var elementName, element;
    elementName = "header_link_" + dest;
    element = document.getElementById(elementName);
    if (element) {analyticsIntegrations.itemClicked("nav clicked", element, dest, null, null, elementName);}
  };

  for (var i=0; i < elementsForLinkTrack.length; i++) {
    destination = elementsForLinkTrack[i];
    addHeaderListener(destination);
    addFooterListener(destination);
  }
};

// Search Page
analyticsIntegrations.searchProductView = function(searchObj, mapAction, listings, action) {
  if (!analyticsIntegrations.segmentLoaded() || !searchObj) {return;}
  var useType = searchObj.space_use;
  var searchKey = searchObj.a;
  var searchType;
  var origin;
  var slashCount;
  var label = location.pathname + location.search;
  if (searchObj.point_of_interest) {
    searchType = 'POI';
  } else if (searchObj.bbox_of_interest) {
    searchType = 'Region';
  } else {
    searchType = 'Metro';
  }

  if (('PUSH' === action)) {
    origin = 'search';
  } else if (document.referrer === (location.origin + '/')) {
    origin = 'home';
  } else if (-1 !== document.referrer.indexOf('/u/')) {
    origin = 'use type';
  } else if (-1 !== document.referrer.indexOf('/venues/')) {
    slashCount = document.referrer.split('/').length;
    origin = 5 < slashCount ? 'keyword' : 'city';
  } else {
    origin = document.referrer;
  }

  const searchKW = PSSessions.Cookies('PSSK');

  var properties = {};
  properties.category = useType;
  properties.label = searchObj.loc_code || (searchObj.address_bbox ? searchObj.address_bbox.replace(/\%20/g, ' ').replace(/\%2C/g, ',') : 'undefined');
  properties.search_key = searchKey;
  properties.search_keyword = searchKW;
  properties.search_keyword_type = PSSessions.Cookies('PSSKT');
  properties.min_guest = searchObj.min_guest;
  properties.max_guest = searchObj.max_guest;
  properties.price_min = searchObj.price_hourly_min;
  properties.price_max = searchObj.price_hourly_max;
  properties.zoom = searchObj.zoom;
  properties.origin = origin;
  properties.url = location.href;
  properties.search_type = searchType;
  properties.viewport_bbox = searchObj.viewport_bbox;
  properties.lat = searchObj.point_of_interest ? JSON.parse(searchObj.point_of_interest)[0] : undefined;
  properties.long = searchObj.point_of_interest ? JSON.parse(searchObj.point_of_interest)[1] : undefined;
  properties.listing_count = listings.length;
  properties.map_search = mapAction || false;
  properties.nonInteraction = 1;
  analytics.track("Viewed Product Category", properties, {
    Quantcast: {
      labels: [ searchKW, useType ]
    }
  });
};

analyticsIntegrations.locationModal = function (location) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  var properties = {};
  var origin = location;
  if ('modal' === origin ) {
    origin = location.href;
  }
  properties.origin = origin;
  analytics.track("search: see all locations", properties);
};

analyticsIntegrations.searchEmail = function (results, queryObj, location) {
  if (!analyticsIntegrations.segmentLoaded() || !results) {return;}
  var searchType;
  var origin = location;
  var results = results[0];

  if ('modal' === origin ) {
    origin = location.href;
  }

  if ('APPROXIMATE' === results.geometry.location_type) {
    searchType = 'Region';
  } else {
    searchType = 'POI';
  }

  var properties = {};
  properties.category = queryObj.space_use;
  properties.label = results.formatted_address;
  properties.origin = origin;
  properties.search_type = searchType;
  properties.lat = results.geometry.location.lat();
  properties.long = results.geometry.location.lng();
  properties.nonInteraction = 1;
  analytics.track('search: location not live', properties);
};

analyticsIntegrations.searchError = function (inputValue, location, paramNotFound) {
  if (!analyticsIntegrations.segmentLoaded() || !inputValue) {return;}
  var properties = {};
  var origin = location;
  if ('modal' === origin) {
    origin = location.href;
  }
  properties.label = inputValue;
  properties.origin = origin;
  properties.nonInteraction = 1;
  analytics.track('search: ' + paramNotFound + ' not found', properties);
};

// Sign up viewed, account created
analyticsIntegrations.signupForm = function signupFormAnalytic (signupAction, extraAttrs, profile) {
  /* extraAttrs: source, method */
  var actionSource;
  var urlSource = extraAttrs.source;

  if (!analyticsIntegrations.segmentLoaded()) { return; }
  function getAction () {
    // sets actionSource also;
    var action;
    switch (urlSource) {
      case 'fav' :
        action = 'save';
        actionSource = 'details';
        break;
      case 'favc' :
        action = 'save';
        actionSource = 'carousel';
        break;
      case 'favt' :
        action = 'save';
        actionSource = 'thumbnail';
        break;
      case 'fee' :
        action = 'start_bkg';
        actionSource = 'details';
        break;
      case 'feec' :
        action = 'start_bkg';
        actionSource = 'carousel';
        break;
      case 'msg' :
        action = 'msg_host';
        actionSource = 'details';
        break;
      case 'host' :
        action = 'list_space';
        actionSource = 'hero';
        break;
      case 'hostf' :
        action = 'list_space';
        actionSource = 'footer';
        break;
      case 'log' :
        action = 'log_in';
        break;
      case 'nav' :
        action = 'sign_up';
        break;
      case 'referred' :
        action = 'referred';
        break;
      default:
        action = 'none';
    }
    return action;
  }
  var action = getAction();

  var getPageType = function getPageType () {
    var splitPath = _.words(location.pathname);
    var parsedPath = !splitPath[0] ? 'home' : ( 'pages' === splitPath[0]) ? splitPath[1] : splitPath[0];
    var pageType;
    switch (parsedPath) {
      case 's':
        pageType = 'search';
        break;
      case 'u':
        pageType = 'use type';
        break;
      case 'plan':
        pageType = 'activity';
        break;
      case 'venues':
        pageType = 'keyword';
        break;
      case 'listings':
        pageType = 'listing';
        break;
      default:
        pageType = parsedPath;  /* home, host, signin, bkc, etc. */
    }
    return pageType;
  };

  var page_type = getPageType();
  var use_type = PSSessions.Cookies('PSUT') || 'none';
  var metro = PSSessions.Cookies('PSmetro') || 'none';
  var activity = PSSessions.Cookies('PSSK') || 'none';
  var path = location.pathname;
  var app = 'web';
  var category = [metro, use_type, activity].join('/');

  var isLoginOrSignup = !!(('sign_up' === action) || ('log_in' === action));
  var isAccountCreated = 'account created' === signupAction;
  var source = _.without([action , (isLoginOrSignup ? 'nav' : page_type), actionSource], undefined).join(' ').trim();
  var email_opt_out = _.get(profile, 'email_unsubscribes.all', false);

  var attrs = {
    page_type: page_type,
    metro: metro,
    activity: activity,
    path: path,
    app: app,
    source: source,
    label: source,
    category: category,
    use_type: use_type,
    action: action,
    ...(isAccountCreated && { email_opt_out: email_opt_out })
  };

  var attrsToSubmit = extraAttrs.method ? _.merge(attrs, { method: extraAttrs.method }) : attrs;

  if (PSSessions.Cookies('host-ref-promo')) {
    attrs.referral_code = PSSessions.Cookies('host-ref-promo');
    attrs.referral_type = 'host_referral';
    attrs.referral_user = PSSessions.Cookies('host-ref-promo-user-id');
  }

  const actions = ['account created', 'signup profile form submitted']
  if (_.isEmpty(profile) || !_.includes(actions, signupAction)) {
    return analytics.track(signupAction, attrsToSubmit);
  }

  var ssoId = profile.SSOid;
  var identifyProps = {
    id: ssoId,
    email: profile.username,
    createdAt: profile.date_created,
    is_logged_in: true
  };

  if ('account created' === signupAction) {
    attrsToSubmit.context = {
      traits: identifyProps
    };
    analytics.alias(ssoId);
    analytics.identify(ssoId, identifyProps);
    analytics.track("account created", attrsToSubmit);
  } else if ('signup profile form submitted' === signupAction) {
    const properties = {
      heard_about_us: profile.heard_about_us,
      user_id: profile._id,
      timestamp: Date.now()
    };

    analytics.identify(ssoId, { ...identifyProps, heard_about_us: profile.heard_about_us });
    analytics.track("signup profile form submitted", {...properties, ...attrsToSubmit});
  }
};

// Log In / Log Out
analyticsIntegrations.accountLogin = function(ssoId){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {};
  properties.ssoID = ssoId;
  properties.category = "Account";
  properties.is_logged_in = true;
  analytics.identify(ssoId, properties);
  analytics.track("account login", { method: 'email', app: 'web', label: 'email' });
};

analyticsIntegrations.accountLogout = function() {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {};
  properties.category = "Account";
  analytics.track("account logout", properties);
  analytics.reset();
};

analyticsIntegrations.hostAddressCollected = function (addressData) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  var properties = {
    city: addressData.city,
    country: addressData.country,
    state: addressData.state,
    street: addressData.street,
    unit: addressData.unit,
    zip: addressData.zip
  };
  properties.app = "web";
  properties.category = "Account";

  if (PSSessions.Cookies('host-ref-promo')) {
    properties.referral_code = PSSessions.Cookies('host-ref-promo');
    properties.referral_type = 'host_referral';
    properties.referral_user = PSSessions.Cookies('host-ref-promo-user-id');
  }

  analytics.track("host address collected", properties);
};

// Profiles
analyticsIntegrations.socialAccountFound = function(method, label) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {
    app: 'web'
  };
  properties.method = method;
  properties.label = label;
  analytics.track('social account found', properties);
};

analyticsIntegrations.socialEmailChanged = function(method, label) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {
    app: 'web'
  };
  properties.method = method;
  properties.label = label;
  analytics.track('social email changed', properties);
};

analyticsIntegrations.socialAccountLogin = function(method, label, ssoId, skipIdentifyCall) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {
    app: 'web'
  };
  properties.method = method;
  properties.label = label;
  properties.ssoID = ssoId;
  properties.category = "Account";
  properties.is_logged_in = true;
  if (!skipIdentifyCall) {
    analytics.identify(ssoId, properties);
  }
  analytics.track('account login', properties);
};

analyticsIntegrations.resendVerification = function(){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("resend verification", {
    verifying: "email"
  });
};

analyticsIntegrations.updateProfile = function(response){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var profile = response.profile;
  var ssoId = profile.SSOid;
  var properties = {};
  properties.avatar = profile.avatar_url || null;
  properties.firstName = profile.first_name || null;
  properties.lastName = profile.last_name || null;
  properties.address = {postalCode: profile.zip || null};
  properties.phone = profile.phone || null;
  properties.title = profile.profession || null;
  properties.organization = profile.organization || null;
  analytics.identify(ssoId, properties);
};

analyticsIntegrations.hostGuestIntent = function(ssoId, intent){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var properties = {};
  properties.signup_intent = intent;
  analytics.identify(ssoId, properties);
};

analyticsIntegrations.whichModalOpened = function(whichModal){
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.page({
    title: whichModal,
    url: window.location.toString(),
    path: window.location.hash,
    referrer: document.referrer
  });
};

analyticsIntegrations.trackLinkClick = function (whichLink) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("link clicked", {
    category: "Account",
    label: whichLink,
    url: window.location.toString(),
    selection: whichLink
  });
};

analyticsIntegrations.failedHostReferral = function (referralCode, referringHostSSO) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('referral failed', {
    reason: 'user already exists',
    referral_code: referralCode,
    referral_type: 'host_referral',
    referral_user: referringHostSSO || PSSessions.Cookies('host-ref-promo-user-id') || 'none'
  });
};

analyticsIntegrations.trackAddServices = function (booking) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('Add Services', {
    origin: 'booking_requested', // this will be the source, currently only the post-booking request confirmation
    booking_id: booking._id,
    guest_id: booking.guest_id,
    listing_id: booking.listing_id,
    listing_metro: booking.listing.metro,
    use_type: booking.listing.use_type
  });
};

analyticsIntegrations.profileShareModalView = function (profileId) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  const properties = {};
  properties.profile_id = profileId;
  properties.category = "profiles";
  properties.origin = "share profile";

  analytics.track("share modal viewed", properties);
};

analyticsIntegrations.messageHostProfileClick = function (profileId) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track("message host profile clicked");
};


analyticsIntegrations.profileShareBtnClick = function (profileId, whichShareBtn) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  const properties = {};
  properties.origin = "share profile";
  properties.profile_id = profileId;
  properties.label = whichShareBtn;
  properties.category = "profiles";

  analytics.track("share button clicked", properties);
};

analyticsIntegrations.listingShareModalView = function (listingObject) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  const useType = listingObject.use_type;
  const metro = listingObject.metro || "unknown";
  const neighborhood = listingObject.neighborhood || "unknown";
  const category = useType + "/" + metro + "/" + neighborhood;
  const properties = analyticsIntegrations.normalizeListingObj(listingObject);
  properties.origin = "share listing profile";
  properties.category = category;

  analytics.track("share modal viewed", properties);
};

analyticsIntegrations.listingShareBtnClick = function (listingObject, whichShareBtn) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }

  const useType = listingObject.use_type;
  const metro = listingObject.metro || "unknown";
  const neighborhood = listingObject.neighborhood || "unknown";
  const category = useType + "/" + metro + "/" + neighborhood;
  const properties = analyticsIntegrations.normalizeListingObj(listingObject);
  properties.origin = "share listing profile";;
  properties.label = whichShareBtn;
  properties.category = category;

  analytics.track("share button clicked", properties);
};

// Public Attendee Page
analyticsIntegrations.publicAttendee = function publicAttendee (trackerStr, propertiesObj) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track(trackerStr, propertiesObj);
};

analyticsIntegrations.attendeeEdit = function (fieldName, fieldVal, bookingId) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var eventName = 'attendee details: ' + fieldName + ' edited';
  var val = 'object' === typeof fieldVal ? JSON.stringify(fieldVal) : fieldVal;
  var properties = {};
  properties.label = bookingId;
  properties[fieldName] = val;

  analytics.track(eventName, properties);
};

// Form Submits
analyticsIntegrations.formSubmit = function (formName) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('form attempt', { 'form name': formName }, { integrations: {
    'All': false,
    'Mixpanel': true
  } });
};

analyticsIntegrations.formFail = function (formName, reason) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var eventName = 'form failure';
  analytics.track(eventName,
    { 'fail reason': reason || 'not provided',
      'request path': formName
    },
    { integrations: {
      'All': false,
      'Mixpanel': true
    } }
  );
};

analyticsIntegrations.requestFail = function (formName, reason) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  var eventName = 'request failure';
  analytics.track(eventName,
    { 'fail reason': reason || 'not provided',
      'request path': formName
    },
    { integrations: {
      'All': false,
      'Mixpanel': true
    } }
  );
};

analyticsIntegrations.formSuccess = function (formName) {
  if (!analyticsIntegrations.segmentLoaded()) { return; }
  analytics.track('form success', { 'form name': formName }, { integrations: {
    'All': false,
    'Mixpanel': true
  }});
};

// Booking and Messages
analyticsIntegrations.inboxProductView = function (viewed, origin) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  var properties = {};

  properties.origin = origin || analyticsIntegrations.getOrigin();
  properties.url = window.location.toString();
  properties.nonInteraction = 1;
  analytics.track(viewed, properties);
};

analyticsIntegrations.inboxDetailsView = function (payload) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  var properties = {};
  var origin;

  if (-1 !== document.referrer.indexOf('/inbox')) {
    origin = 'inbox';
  } else if (-1 !== document.referrer.indexOf('/bookings')) {
    origin = 'bookings';
  } else {
    origin = document.referrer;
  }
  var useType = payload.listing ? payload.listing.use_type : '';
  properties.origin = origin;
  properties.category = useType + '/' + payload.metro;
  properties.url = window.location.toString();
  properties.user_host = 'HOST' === payload.view_as ? true : false;
  properties.nonInteraction = 1;
  var mergeObject = analyticsIntegrations.mergeObject(properties,payload)
  analytics.track('Viewed Inbox Detail Page', mergeObject);
};

analyticsIntegrations.detailsAction = function (viewed, payload) {
  var properties = {};
  var useType = payload.listing ? payload.listing.use_type : payload.use_type;
  properties.origin = 'booking';
  properties.category = useType + '/' + payload.metro;
  var mergeObject = analyticsIntegrations.mergeObject(properties,payload)
  analytics.track(viewed, mergeObject);
};

analyticsIntegrations.mutinyDetails = function () {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  if ('object' === typeof window.mutinyData) {
    analytics.track('mutiny loaded', { mutiny_data: JSON.stringify(window.mutinyData) }, { integrations: {
      'All': false,
      'bigquery': true
    }});
  }
};

// Landing Page Test
analyticsIntegrations.videoSectionViewed = function (youtubeID) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  analytics.track('video section viewed', {
    youtube_id: youtubeID,
    nonInteraction: 1
  });
};

analyticsIntegrations.landingPageVideoPlayed = function (youtubeID) {
  if (!analyticsIntegrations.segmentLoaded()) {return;}
  analytics.track('video played', {
    youtube_id: youtubeID,
    nonInteraction: 1
  });
};

// Loading Functions
analyticsIntegrations.mainFunctionsLoad = function(){
  analyticsIntegrations.bugsnagDetails();
};
loadSegmentProfilePage = function() {
  analyticsIntegrations.mainFunctionsLoad();
  analyticsIntegrations.addShareEventListeners();
  analyticsIntegrations.addListingBlockEventListeners();
  analyticsIntegrations.addNavFooterListeners();
};
loadSegmentListingPage = function(){
  analyticsIntegrations.mainFunctionsLoad();
  analyticsIntegrations.addShareEventListeners();
  analyticsIntegrations.listingsProductView(listingJSON);
  analyticsIntegrations.addNavFooterListeners();
};
loadSegmentUsePage = function(){
  analyticsIntegrations.mainFunctionsLoad();
  analyticsIntegrations.addNavFooterListeners();
  analyticsIntegrations.addListingBlockEventListeners();
  analyticsIntegrations.heroSectionEventListener();
  analyticsIntegrations.conciergeSectionListener();
  analyticsIntegrations.bannerSectionEventListener();
  analyticsIntegrations.mutinyDetails();
};

loadSegmentMarketingPage = function(){
  analyticsIntegrations.mainFunctionsLoad();
  analyticsIntegrations.addNavFooterListeners();
  analyticsIntegrations.heroSectionEventListener();
  analyticsIntegrations.bannerSectionEventListener();
  analyticsIntegrations.learnMoreSectionEventListener();
  analyticsIntegrations.eventPlanningSectionEventListener();
  analyticsIntegrations.joinUsEventListener();
  analyticsIntegrations.searchEventListener();
};
window.loadSegmentSearchPage = function(){
  analyticsIntegrations.mainFunctionsLoad();
};
